export const createPeriodSelectionSelector = state => state.projects.createPeriod.selection;

export const createPeriodPayloadSelector = state => state.projects.createPeriod.payload;
